module.exports = __webpack_public_path__ + "img/Footer.8b13f31e.png";